"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Table = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ArrowUpward = _interopRequireDefault(require("@material-ui/icons/ArrowUpward"));
var _ArrowDownward = _interopRequireDefault(require("@material-ui/icons/ArrowDownward"));
var _styles = require("@material-ui/core/styles");
var _lodash = _interopRequireDefault(require("lodash"));
var _core = require("@material-ui/core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable react/no-array-index-key */

const useStyles = (0, _styles.makeStyles)({
  table: {
    minWidth: 650
  },
  link: {
    color: '#212529'
  },
  orderedCell: {
    '& span': {
      marginLeft: 4,
      marginTop: 2,
      transition: 'all .2s',
      position: 'absolute'
    },
    '&:hover': {
      cursor: 'pointer'
    }
  },
  hide: {
    color: 'transparent'
  }
});
const Table = _ref => {
  let {
    cells,
    rows,
    displayRowCheckbox,
    onCheckRows,
    selectedRows,
    disableCheckAll
  } = _ref;
  const classes = useStyles();
  const [rowsPerPage, setRowsPerPage] = (0, _react.useState)(10);
  const [page, setPage] = (0, _react.useState)(0);
  const [tableRows, setTableRows] = (0, _react.useState)();
  const [orderState, setOrderState] = (0, _react.useState)('asc');
  (0, _react.useEffect)(() => {
    const rowsPerPageStorage = localStorage.getItem('rowsPerPage');
    if (rowsPerPageStorage) {
      setRowsPerPage(rowsPerPageStorage);
    }
  }, []);
  (0, _react.useEffect)(() => {
    setTableRows(rows);
  }, [rows]);
  const renderSelectRow = row => {
    if (!displayRowCheckbox) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement(_core.TableCell, {
      padding: "checkbox"
    }, /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
      checked: !!selectedRows.find(sr => sr.key === row.key),
      color: "primary",
      onChange: evt => {
        if (evt.target.checked) {
          onCheckRows([...selectedRows, row]);
        } else {
          onCheckRows(selectedRows.filter(sr => sr.key !== row.key));
        }
      }
    }));
  };
  const renderSelectAllRows = () => {
    if (!displayRowCheckbox) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement(_core.TableCell, {
      padding: "checkbox"
    }, !disableCheckAll && /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
      checked: tableRows && tableRows.length === selectedRows.length,
      color: "primary",
      onChange: evt => {
        if (evt.target.checked) {
          onCheckRows(tableRows);
        } else {
          onCheckRows([]);
        }
      }
    }));
  };
  const renderCellValue = (row, column) => {
    const value = row[column];
    const {
      redirectTo
    } = row;
    if (redirectTo && redirectTo.fromColumn === column) {
      return /*#__PURE__*/_react.default.createElement("a", {
        href: redirectTo.path,
        className: classes.link
      }, value);
    }
    return value;
  };
  const orderBy = param => {
    if (orderState === 'asc') {
      setTableRows(_lodash.default.sortBy(tableRows, param));
      setOrderState('desc');
    }
    if (orderState === 'desc') {
      setTableRows(_lodash.default.sortBy(tableRows, param).reverse());
      setOrderState('default');
    }
    if (orderState === 'default') {
      setTableRows(rows);
      setOrderState('asc');
    }
  };
  const handleArrows = () => {
    if (orderState === 'asc') {
      return /*#__PURE__*/_react.default.createElement(_ArrowUpward.default, {
        fontSize: "small"
      });
    }
    if (orderState === 'desc') {
      return /*#__PURE__*/_react.default.createElement(_ArrowDownward.default, {
        fontSize: "small"
      });
    }
    return /*#__PURE__*/_react.default.createElement(_ArrowDownward.default, {
      className: classes.hide,
      fontSize: "small"
    });
  };
  return /*#__PURE__*/_react.default.createElement(_core.TableContainer, {
    component: _core.Paper
  }, /*#__PURE__*/_react.default.createElement(_core.Table, {
    className: classes.table
  }, /*#__PURE__*/_react.default.createElement(_core.TableHead, null, /*#__PURE__*/_react.default.createElement(_core.TableRow, null, renderSelectAllRows(), cells.map((cell, index) => cell.order ? /*#__PURE__*/_react.default.createElement(_core.TableCell, {
    className: classes.orderedCell,
    key: `cell-${index}`,
    component: "th",
    onClick: () => orderBy(cell.code)
  }, cell.name, /*#__PURE__*/_react.default.createElement("span", null, handleArrows())) : /*#__PURE__*/_react.default.createElement(_core.TableCell, {
    key: `cell-${index}`,
    component: "th"
  }, cell)))), /*#__PURE__*/_react.default.createElement(_core.TableBody, null, tableRows && (rowsPerPage > 0 ? tableRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : tableRows).map(row => /*#__PURE__*/_react.default.createElement(_core.TableRow, {
    key: `tr-${row.key}`,
    selected: displayRowCheckbox && !!selectedRows.find(sr => sr.key === row.key),
    hover: true,
    className: row.className
  }, renderSelectRow(row), Object.keys(row).filter(column => !['key', 'redirectTo', 'className'].includes(column)).map((column, index) => /*#__PURE__*/_react.default.createElement(_core.TableCell, {
    key: `td-${index}`,
    component: "td",
    scope: "row"
  }, renderCellValue(row, column)))))), /*#__PURE__*/_react.default.createElement(_core.TableFooter, null, /*#__PURE__*/_react.default.createElement(_core.TableRow, null, /*#__PURE__*/_react.default.createElement(_core.TablePagination, {
    rowsPerPageOptions: [10, 50, 100],
    colSpan: cells.length + 1,
    count: tableRows && tableRows.length,
    rowsPerPage: rowsPerPage,
    page: page,
    onChangePage: (evt, newPage) => setPage(newPage),
    onChangeRowsPerPage: evt => {
      localStorage.setItem('rowsPerPage', evt.target.value);
      setRowsPerPage(evt.target.value);
    }
  })))));
};
exports.Table = Table;
Table.defaultProps = {
  displayRowCheckbox: false,
  onCheckRows: null,
  selectedRows: null,
  disableCheckAll: false
};
Table.propTypes = {
  /**
   * Array de objetos com os dados que deve conter em cada linha da tabela
   */
  rows: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  /**
   * Array de strings que contém o nome das colunas da tabela
   */
  cells: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  /**
   * Exibir ou ocultar o checkbox de seleção de linhas
   */
  displayRowCheckbox: _propTypes.default.bool,
  /**
  /**
   * Exibir ou ocultar o checkbox de seleção de linhas
   */
  disableCheckAll: _propTypes.default.bool,
  /**
   * Função disparada no momento que uma ou mais linhas são seleciondas
   */
  onCheckRows: _propTypes.default.func,
  /**
   * Array de objetos com as linhas que foram seleciondas
   */
  selectedRows: _propTypes.default.arrayOf(_propTypes.default.object)
};
var _default = exports.default = Table;